<template>
  <div id="page">
    <!-- <h2>查询订单</h2>
    <div>
      <label>姓名</label>
      <input placeholder="请输入姓名" v-model="name">
    </div>
    <div>
      <label>身份证号</label>
      <input placeholder="请输入身份证号" v-model="idNo">
    </div>
    <div>
      <label>手机号</label>
      <input placeholder="请输入手机号" v-model="mobile">
    </div>
    <div>
      <label>验证码</label>
      <input placeholder="验证码" v-model="smsCode"> <button>获取</button>
    </div>

    <div>
      <button @click="queryOrder()">查询</button>
    </div> -->
    <b-modal ok-only ref="model_error" title="提示" @ok="handleOk" ok-title="确定">
      <p class="my-4">{{errorMsg}}</p>
    </b-modal>
  </div>

</template>

<script>
  import axios from 'axios'
  export default {
    name: 'QueryOrder',
    data() {
      return {
        name: '',
        idNo: '',
        mobile: '',
        smsCode: '',
        bankCode: '',
        bankSerialNumber: '',
        errorMsg: '',
      }
    },
    mounted: function() {
      this.bankSerialNumber = this.$route.query.bankSerialNumber
      console.log("bankSerialNumber:" + this.bankSerialNumber);
      this.bankCode = this.$route.query.bankCode;
      console.log("bankCode:" + this.bankCode);
      this.queryOrder();
    },
    methods: {
      handleOk: function(bvModalEvt) {
        this.$router.go(-1);
      },
      showErrorMsg: function() {
        this.$refs['model_error'].show();
      },
      hideErrorMsg: function() {
        this.$refs['model_error'].hide();
      },
      showLoading: function() {
        this.$showLoading();
      },
      hideLoading: function() {
        this.$hideLoading();
      },
      queryOrder: function() {
        var that = this;
        that.showLoading();
        axios.post('https://cp.hengbao.net.cn/pos/order/queryOrder', {
            bankCode: this.bankCode,
            bankSerialNumber: this.bankSerialNumber
          })
          .then(function(response) {
            /* {
              "code": 0,
              "message": null,
              "projectName": "DIY",
              "orderModelList": [{
                "orderNo": "01222404618637029376",
                "orderDateTime": "2020-03-10 14:12:50",
                "orderStatus": "制卡完成",
                "orderStatsNo": 8,
                "courierCompany": "",
                "trackNumber": "",
                "orderType": "1",
                "price": 1,
                "auditFailCause": null,
                "modelType": 0,
                "modelClass": 0,
                "backgroundColor": "201C",
                "cardClass": 1,
                "address": "北京市西城区新盛大厦B-8层",
                "orderStep": 3,
                "cardTypeName": "借记卡",
                "thumbnailFileUrl": "group1/M00/00/03/MgAAaF5nL-KAcaymAAHTkobYNwU311.png"
              }]
            } */
            that.hideLoading();
            console.log(response);
            var data = response.data;
            var dataString = JSON.stringify(data);
            console.log(dataString);


            if (data.code === 0) {
              var temp = data.queryOrderModel;
              var orders = new Array(temp);
              var obj = {
                projectName: data.projectName,
                orders: orders,
              }
              that.toOrderList(obj);
            } else {
              that.errorMsg = data.message;
              that.showErrorMsg();
            }
          })
          .catch(function(error) {
            that.hideLoading();
            console.log(error);
          });
      },
      toOrderList: function(resultObj) {
        var queryResult = JSON.stringify(resultObj);
        this.$router.replace({
          name: 'OrderList',
          params: {
            queryResult: queryResult
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/QueryOrder.vue